import Vue from 'vue'
import Application from './App.vue'
import Vuex from 'vuex'
import store from './common/Store';
import router from './router';
import VueSocialSharing from 'vue-social-sharing'
import VueAnalytics from 'vue-analytics';
Vue.use(Vuex);
Vue.use(VueSocialSharing);
Vue.prototype.$eventBus = new Vue()
/*
Vue.use(VueAnalytics, {
  id: 'UA-99688542-16',
  router
});
*/
// Create a quiz object with a title and two questions.
// A question has one or more answer, and one or more is valid.
import quiz from "./appdata/quiz";
var App = Object.freeze({
  name: 'Owned',
  quiz: quiz,
});

 

Vue.prototype.App = App;
new Vue({
  el: '#app',
  router,
  watch: {
    $route: function (to) {
      
      this.$nextTick(function () {
        /*let refs = this.$root.$children[0].$refs;
        setTimeout(() => {

          // Get component's "routeFocusTarget" ref. 
          // If not existent, use router view container
          let focusTarget = (refs.routerView.$refs.focusTarget !== undefined) 
          ? refs.routerView.$refs.focusTarget
          : refs.routerView.$el;

          // Make focustarget programmatically focussable
          focusTarget.setAttribute('tabindex', '-1');

          // Focus element
          focusTarget.focus();

          // Remove tabindex from focustarget. 
          // Reason: https://axesslab.com/skip-links/#update-3-a-comment-from-gov-uk
          focusTarget.removeAttribute('tabindex');
        }, 0);*/
      })  
    }
  },
  store,
  
  render: h => h(Application)
})

Vue.filter('striphtml', function (value) {
  var div = document.createElement("div");
  div.innerHTML = value;
  var text = div.textContent || div.innerText || "";
  return text;
});

import Question from './components/steps/Question'



//router.replace('/')


// WEBPACK FOOTER //
// ./src/main.js